import { showToast, showErrorToast } from '~/utils/toast-notifications';

// TODO from Nikola: a lot of the actions below (likes, favorites, replies, deletes) are
// basically copy-pasted into home/market/profile/post/portfolio/hashtags/
// cryptoNews/companyProfile too. Worth pulling into one shared place so we're
// not making the same change nine times in case we introduce new things to posts later on
export default {
  createAdminLeague(context, payload) {
    context.commit('CREATE_ADMIN_LEAGUE_INIT');
    return this.dispatch('api/createAdminLeague', payload)
      .then((res) => {
        context.commit('CREATE_ADMIN_LEAGUE_SUCCESS', res.data);
        context.commit('APPEND_LEAGUES_TO_LEAGUES', res.data);
        // window.$nuxt.$notify.success(
        //   window.$nuxt.$t('league_creation_success')
        // );
        showToast(window.$nuxt.$t('added_to_favorites_toast'));
      })
      .catch((err) => {
        context.commit('CREATE_ADMIN_LEAGUE_ERROR', err);
        window.$nuxt.$notify.error(window.$nuxt.$t('league_creation_error'));
      });
  },
  getLeagues(context, query) {
    context.commit('GET_LEAGUES_INIT');
    return this.dispatch('api/searchLeagues', query)
      .then((res) => {
        context.commit('GET_LEAGUES_SUCCESS', res.data);
      })
      .catch((err) => {
        context.commit('GET_LEAGUES_ERROR', err);
      });
  },
  getPendingProfileInvitations(context) {
    context.commit('GET_PENDING_INVITATIONS_INIT');
    return this.dispatch('api/getPendingProfileInvitations')
      .then((res) => {
        context.commit('APPEND_PENDING_PROFILE_INVITATIONS', res.data);
      })
      .catch((err) => {
        context.commit('GET_PENDING_INVITATIONS_ERROR', err);
      });
  },
  answerLeagueInvitation(context, payload) {
    return this.dispatch('api/answerLeagueInvitation', payload)
      .then(() => {
        context.commit('REMOVE_ANSWERED_INVITATION', payload);
      })
      .catch((err) => {
        context.commit('ANSWER_LEAGUE_INVITATION_ERROR', err);
      });
  },
  getLeagueById(context, payload) {
    context.commit('GET_LEAGUE_BY_ID_INIT');
    return this.dispatch('api/getLeagueById', payload)
      .then((res) => {
        context.commit('GET_LEAGUE_BY_ID_SUCCESS', res.data);
      })
      .catch((err) => {
        context.commit('GET_LEAGUE_BY_ID_ERROR', err);
      });
  },
  getLeagueRulesById(context, payload) {
    context.commit('GET_LEAGUE_RULES_BY_ID_INIT');
    return this.dispatch('api/getLeagueRulesById', payload)
      .then((res) => {
        context.commit('GET_LEAGUE_RULES_BY_ID_SUCCESS', res.data);
      })
      .catch((err) => {
        context.commit('GET_LEAGUE_RULES_BY_ID_ERROR', err);
      });
  },
  getLeagueLeaderboard(context, payload) {
    context.commit('GET_LEAGUE_LEADERBOARD_INIT');
    return this.dispatch('api/getLeagueLeaderboard', payload)
      .then((res) => {
        context.commit('GET_LEAGUE_LEADERBOARD_SUCCESS', res.data);
      })
      .catch((err) => {
        context.commit('GET_LEAGUE_LEADERBOARD_ERROR', err);
      });
  },
  getMyLeaguePortfolios(context, payload) {
    context.commit('GET_MY_LEAGUE_PORTFOLIOS_INIT');
    return this.dispatch('api/getMyLeaguePortfolios', payload)
      .then((res) => {
        context.commit('GET_MY_LEAGUE_PORTFOLIOS_SUCCESS', res.data);
      })
      .catch((err) => {
        context.commit('GET_MY_LEAGUE_PORTFOLIOS_ERROR', err);
      });
  },
  getLeaguePortfolios(context, payload) {
    context.commit('GET_LEAGUE_PORTFOLIOS_INIT');
    return this.dispatch('api/getLeaguePortfolios', payload)
      .then((res) => {
        context.commit('GET_LEAGUE_PORTFOLIOS_SUCCESS', res.data);
      })
      .catch((err) => {
        context.commit('GET_LEAGUE_PORTFOLIOS_ERROR', err);
      });
  },
  submitLeaguePassword(context, payload) {
    context.commit('SUBMIT_LEAGUE_PASSWORD_INIT');
    return this.dispatch('api/submitLeaguePassword', payload)
      .then((res) => {
        if (res.data.success) {
          context.commit('SUBMIT_LEAGUE_PASSWORD_SUCCESS', res.data);
          showToast(window.$nuxt.$t('league_password_success'));
        } else {
          context.commit('SUBMIT_LEAGUE_PASSWORD_FAILED', res.data.error);
          showErrorToast(window.$nuxt.$t('league_password_incorrect'));
        }
      })
      .catch((err) => {
        context.commit('SUBMIT_LEAGUE_PASSWORD_ERROR', err);
      });
  },
  resetPasswordState(context) {
    context.commit('SUBMIT_LEAGUE_PASSWORD_INIT');
  },
  getLeagueFeed(context, payload) {
    // GET_LEAGUE_FEED_START keeps the existing posts visible (no skeleton)
    // when leagueId matches what's already loaded, and just refreshes them
    // in the background.
    context.commit('GET_LEAGUE_FEED_START', payload.leagueId);
    return this.dispatch('api/getLeagueFeed', payload)
      .then((res) => {
        context.commit('GET_LEAGUE_FEED_SUCCESS', {
          data: res.data,
          leagueId: payload.leagueId,
        });
      })
      .catch((err) => {
        context.commit('GET_LEAGUE_FEED_ERROR', err);
      })
      .finally(() => {
        context.commit('SET_LEAGUE_FEED_LOADING', false);
      });
  },
  getNextLeaguePosts(context, payload) {
    context.commit('SET_NEXT_FEED_POSTS_LOADING', true);
    return this.dispatch('api/getLeagueFeed', payload)
      .then((res) => {
        context.commit('GET_NEXT_FEED_POSTS_SUCCESS', res.data);
        return res.data;
      })
      .catch((err) => {
        console.error('Error fetching next league feed posts', err);
      })
      .finally(() => {
        context.commit('SET_NEXT_FEED_POSTS_LOADING', false);
      });
  },
  appendNewPostAtTop(context, post) {
    context.commit('APPEND_NEW_POST_AT_TOP', post);
  },
  appendNewReplyTop(context, data) {
    context.commit('APPEND_NEW_REPLY', data);
  },
  postComment(context, payload) {
    return this.dispatch('api/createPost', payload)
      .then((res) => {
        showToast(window.$nuxt.$t('post_created_ok'));
        context.commit('APPEND_NEW_REPLY', res.data);
      })
      .catch((err) => {
        showErrorToast(window.$nuxt.$t('error_occured_message'));
        console.error(err);
      });
  },
  updatePostAfterEdit(context, post) {
    showToast(window.$nuxt.$t('post_updated_ok'));
    context.commit('UPDATE_POST_AFTER_EDIT', post);
  },
  updateReply(context, payload) {
    return this.dispatch('api/updatePost', payload.data)
      .then((res) => {
        showToast(window.$nuxt.$t('post_updated_ok'));
        res.data.updatedDate = payload.data.updatedDate;
        context.commit('UPDATE_REPLY_AFTER_EDIT', {
          postId: payload.postId,
          data: res.data,
        });
      })
      .catch(() => {
        showErrorToast(window.$nuxt.$t('error_occured_message'));
      });
  },
  appendNestedReplyTop(context, payload) {
    context.commit('APPEND_NESTED_REPLY_TOP', payload);
  },
  incrementReplyReplyCount(context, payload) {
    if (!payload)
      throw new Error('incrementReplyReplyCount: payload is required');
    if (!payload.postId)
      throw new Error('incrementReplyReplyCount: payload.postId is required');
    context.commit('INCREMENT_REPLY_REPLY_COUNT', payload);
  },
  likePost(context, payload) {
    context.commit('UPDATE_POST_LIKE_OPTIMISTIC', payload);
    this.dispatch('api/likePost', payload.postId)
      .then((res) => {
        context.commit('UPDATE_POST_LIKE', res.data);
      })
      .catch((err) => {
        context.commit('ROLLBACK_POST_LIKE', payload);
        context.commit('SET_ERROR', err);
      });
  },
  favoritePost(context, payload) {
    this.dispatch('api/favoritePost', payload)
      .then((res) => {
        context.commit('UPDATE_POST_FAVORITE', res.data);
      })
      .catch((err) => {
        console.error('Error favoriting post', err);
      });
  },
  favoriteReply(context, payload) {
    return this.dispatch('api/favoritePost', payload)
      .then((res) => {
        context.commit('UPDATE_REPLY', res.data);
      })
      .catch((err) => {
        console.error('Error favoriting reply', err);
      });
  },
  likeReply(context, payload) {
    context.commit('UPDATE_REPLY_LIKE_OPTIMISTIC', payload);
    return this.dispatch('api/likePost', payload.replyId)
      .then((res) => {
        context.commit('UPDATE_REPLY', res.data);
      })
      .catch((err) => {
        context.commit('ROLLBACK_REPLY_LIKE', payload);
        console.error('Error liking reply', err);
      });
  },
  deleteUserPost(context, payload) {
    return this.dispatch('api/deleteUserPost', payload)
      .then((res) => {
        context.commit('DELETE_USER_POST_SUCCESS', res.data);
        showToast(window.$nuxt.$t('post_deletion_successful'));
      })
      .catch((err) => {
        showErrorToast(window.$nuxt.$t('error_occured_message'));
        console.error('Error deleting post', err);
      });
  },
  deletePostReply(context, payload) {
    return this.dispatch('api/deleteUserPost', { postId: payload.replyId })
      .then((res) => {
        context.commit('DELETE_POST_REPLY_SUCCESS', {
          postId: payload.postId,
          replyId: res.data,
        });
        showToast(window.$nuxt.$t('post_deletion_successful'));
      })
      .catch((err) => {
        showErrorToast(window.$nuxt.$t('error_occured_message'));
        console.error('Error deleting reply', err);
      });
  },
};
